module.exports = __webpack_public_path__ + "prj_14.456e16b0.jpg";